import { create } from 'zustand';

export type ActiveSection = 'search' | 'availability' | 'statistics' | 'network' | 'obsQuality' | 'observations' | 'dtnEuQuality';

interface NavigationState {
  activeSection: ActiveSection;
  isPanelCollapsed: boolean;
  setActiveSection: (section: ActiveSection) => void;
  togglePanel: () => void;
}

export const useNavigationStore = create<NavigationState>((set) => ({
  activeSection: 'search',
  isPanelCollapsed: true,
  setActiveSection: (section) => set({ activeSection: section }),
  togglePanel: () => set((state) => ({ isPanelCollapsed: !state.isPanelCollapsed })),
}));
